var $48f3f33a29908d4c$exports = {};
$48f3f33a29908d4c$exports = {
    "close": `U\u{17E}daryti`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} prane\u{161}imas`,
            other: ()=>`${formatter.number(args.count)} prane\u{161}imai`
        })}.`
};


export {$48f3f33a29908d4c$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
